//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'order',
  components: {
  },
  data () {
    return {
      id:0,
      info:{
        city:{},
        oil:{},
      },
    }
  },
  created(){
    this.id = Number(this.$route.params.id);
    this.getInfo();
  },
  amount(){
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    search(){
        this.list = [];
        this.lastId = 0;
        this.hasNext = 0;
        this.getList();
    },
    getInfo(){
        this.$api.orderDetial({id:this.id}).then((res)=>{
          if(res){
            this.info = res.data;
          }
        })  
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/deatil.vue